import React from 'react';
import SEO from '../components/SEO.js';
import '../index.css';

function About() {
  return (
    <>
      <SEO
        title="About RapidMind AI - Our Mission and AI Tools"
        description="Learn about RapidMind AI's mission to empower creators, students, and businesses with advanced AI tools. Discover our commitment to privacy, innovation, and user-friendly AI solutions."
        keywords="about rapidmind ai, AI mission, AI tools for creators, privacy-focused AI, AI for students, freelancers AI tools, business AI solutions"
        image="/RapidMind 2025.png"
        type="website"
      />
      <div   id='about' className="about-container">
        <div className="about-wrapper">
          <h1>About RapidMind AI</h1>
        <p className="intro">
          RapidMind est un outil d'intelligence artificielle conçu pour les étudiants,
          freelancers, entreprises et curieux du savoir. Il permet une interaction naturelle
          avec l'IA à travers des prompts puissants, la reconnaissance vocale, et des fichiers joints.
        </p>

        <div className="section">
          <h2>🎯 Notre Mission</h2>
          <p>
            Aider les utilisateurs à trouver des réponses, créer, apprendre et automatiser 
            leurs tâches quotidiennes grâce à une interface simple, rapide et puissante.
          </p>
        </div>

        <div className="section">
          <h2>🚀 Fonctionnalités Clés</h2>
          <ul>
            <li>Interface claire et intuitive</li>
            <li>Support vocal et upload de fichiers</li>
            <li>Historique des prompts sauvegardé</li>
            <li>Fonctionnalités premium pour les utilisateurs avancés</li>
          </ul>
        </div>

        <div className="section">
          <h2>🔒 Respect de la vie privée</h2>
          <p>
            Vos données ne sont jamais utilisées pour entraîner les modèles.
            RapidMind respecte votre confidentialité.
          </p>
        </div>
      </div>
    </div>
    </>
  );
}

export default About;
